export default "__VITE_ASSET__BwwGFpVm__"